import { QueryClientProvider } from '@tanstack/react-query'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { montarDependencias } from '@/app/dependencias'
import { rotas } from '@/app/router'

const router = createBrowserRouter(rotas)

/**
 * One QueryClient per page load, created at module scope so a re-render cannot
 * replace it and throw the cache away. `montarDependencias()` also registers the
 * logout teardowns — the query cache and the persisted tenant. It is the SAME
 * function the test harness calls, so a dependency wired here is exercised by the
 * suite; see `app/dependencias.ts` for why that stopped being optional.
 *
 * It sits ABOVE the router, and therefore above `SessionProvider`, so the cache
 * survives the bounce to `/login` and back. Emptying it is logout's decision, not
 * navigation's.
 */
const { queryClient } = montarDependencias()

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}
